import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import NuevaSolicitud from "./pages/NuevaSolicitud";
import SolicitudesPendientes from "./pages/SolicitudesPendientes";
import DetalleAprobacion from "./pages/DetalleAprobacion";
import MisAprobaciones from "./pages/MisAprobaciones";
import DetalleMiAprobacion from "./pages/DetalleMiAprobacion";
import GestionarUsuarios from "./pages/GestionarUsuarios";
import GestionarCatalogos from "./pages/GestionarCatalogos";
import DetalleSolicitud from "./pages/DetalleSolicitud";
import DetalleActivoItem from "./pages/DetalleActivoItem";
import CotizacionAsistida from "./pages/CotizacionAsistida";
import BandejaCompras from "./pages/BandejaCompras";
import Historico from "./pages/Historico";
import ConfigurarFirma from "./pages/ConfigurarFirma";
import ConfigurarParametros from "./pages/ConfigurarParametros";
import Actas from "./pages/Actas";
import Activos from "./pages/Activos";
import Reportes from "./pages/Reportes";
import ModoSeguridad from "./pages/ModoSeguridad";
import Pagos from "./pages/Pagos";
import GestionarPago from "./pages/GestionarPago";
import RegistrarPago from "./pages/RegistrarPago";
import Creditos from "./pages/Creditos";
import RegistrarCredito from "./pages/RegistrarCredito";
import { AyudaProvider } from "./context/AyudaContext";
import { apiFetch } from "./utils/api";

function App() {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const guardado = localStorage.getItem("usuario");
    if (guardado) {
      setUsuario(JSON.parse(guardado));
      // Se refresca con lo que hay en la BD por si el administrador le cambió
      // el rol o el área (si lo desactivó, apiFetch cierra la sesión).
      apiFetch("/api/auth/yo")
        .then((actual) => {
          if (!actual) return;
          localStorage.setItem("usuario", JSON.stringify(actual));
          setUsuario(actual);
        })
        .catch(() => {});
    }
    setCargando(false);
  }, []);

  const cerrarSesion = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
    setUsuario(null);
  };

  if (cargando) return null;

  if (!usuario) {
    return <Login onLoginSuccess={setUsuario} />;
  }

  const esAprobador = usuario.rol === "aprobador" || usuario.rol === "administrador";
  const esCompras = usuario.rol === "compras" || usuario.rol === "administrador";
  const esAdmin = usuario.rol === "administrador";
  const esPagos = usuario.rol === "pagos";

  return (
    <AyudaProvider>
    <BrowserRouter>
      <Routes>
        <Route element={<Layout usuario={usuario} onLogout={cerrarSesion} />}>
          {/* Quien paga no tiene Dashboard: su pantalla de inicio es Pagos */}
          <Route path="/" element={esPagos ? <Navigate to="/pagos" replace /> : <Dashboard />} />
          <Route path="/nueva" element={esPagos ? <Navigate to="/pagos" replace /> : <NuevaSolicitud />} />
          <Route path="/solicitud/:id" element={<DetalleSolicitud />} />
          <Route path="/solicitud/:id/activo/:itemId" element={<DetalleActivoItem />} />
          <Route
            path="/solicitud/:id/cotizacion-asistida"
            element={esCompras ? <CotizacionAsistida /> : <Navigate to="/" replace />}
          />
          <Route
            path="/solicitud/:id/cotizacion-asistida/:cotizacionId"
            element={esCompras ? <CotizacionAsistida /> : <Navigate to="/" replace />}
          />
          <Route
            path="/pendientes"
            element={esAprobador ? <SolicitudesPendientes /> : <Navigate to="/" replace />}
          />
          <Route
            path="/aprobadas"
            element={esAprobador ? <MisAprobaciones /> : <Navigate to="/" replace />}
          />
          <Route
            path="/aprobadas/:id"
            element={esAprobador ? <DetalleMiAprobacion /> : <Navigate to="/" replace />}
          />
          <Route
            path="/pendientes/:id"
            element={esAprobador ? <DetalleAprobacion /> : <Navigate to="/" replace />}
          />
          <Route
            path="/bandeja"
            element={esCompras ? <BandejaCompras /> : <Navigate to="/" replace />}
          />
          <Route
            path="/usuarios"
            element={esAdmin ? <GestionarUsuarios /> : <Navigate to="/" replace />}
          />
          <Route
            path="/catalogos"
            element={esCompras ? <GestionarCatalogos /> : <Navigate to="/" replace />}
          />
          <Route path="/historico" element={esPagos ? <Navigate to="/pagos" replace /> : <Historico />} />
          <Route
            path="/actas"
            element={esCompras || esAprobador ? <Actas /> : <Navigate to="/" replace />}
          />
          <Route
            path="/reportes"
            element={esCompras || esAprobador ? <Reportes /> : <Navigate to="/" replace />}
          />
          <Route
            path="/activos"
            element={esCompras || esAprobador ? <Activos /> : <Navigate to="/" replace />}
          />
          <Route
            path="/pagos"
            element={esPagos || esCompras ? <Pagos /> : <Navigate to="/" replace />}
          />
          <Route
            path="/pagos/creditos"
            element={esPagos || esCompras ? <Creditos /> : <Navigate to="/" replace />}
          />
          <Route
            path="/pagos/creditos/:id"
            element={esPagos || esCompras ? <RegistrarCredito /> : <Navigate to="/" replace />}
          />
          <Route
            path="/pagos/:id"
            element={esPagos || esCompras ? <GestionarPago /> : <Navigate to="/" replace />}
          />
          <Route
            path="/pagos/:id/registrar"
            element={esPagos || esCompras ? <RegistrarPago /> : <Navigate to="/" replace />}
          />
          <Route
            path="/firma"
            element={esAdmin ? <ConfigurarFirma /> : <Navigate to="/" replace />}
          />
          <Route
            path="/parametros"
            element={esAdmin ? <ConfigurarParametros /> : <Navigate to="/" replace />}
          />
          <Route
            path="/modo-seguridad"
            element={esAdmin ? <ModoSeguridad /> : <Navigate to="/" replace />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
    </AyudaProvider>
  );
}

export default App;
